import { Card, Flex, Stack } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts';
import FormSearch from './FormSearch';
import FoundSubMerchant from './FoundSubMerchant';
import { useDispatch, useSelector } from 'react-redux';
import { clearRedux, fetchDetailSubMerchant } from './actions';
import { fetchSessionProtection } from '../../components/layouts/PageBase/actions';

const Search = () => {
  const dispatch = useDispatch();

  const { setBreadcrumbs } = useContext(AppContext);

  const {
    search: dataSearch } = useSelector(({ settingSubMerchant }) => settingSubMerchant);

  const [search, setSearch] = useState('');
  const handleSearch = () => {
    dispatch(fetchDetailSubMerchant(search));
  };
  useEffect(() => {
    dispatch(fetchSessionProtection());
    setBreadcrumbs(['Setting Data Subpangkalan LPG 3 Kg']);
    dispatch(clearRedux('search'));
  }, []);
  return (
    <Card withBorder>
      <Flex justify="center">
        <Stack>
          <FormSearch
            data={dataSearch}
            handleSearch={handleSearch}
            search={search}
            setSearch={setSearch}
          />
          {dataSearch?.data && <FoundSubMerchant data={dataSearch?.data}/>}
        </Stack>
      </Flex>
    </Card>
  );
};

export default Search;
